import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=6520fa91&lang=pug&"
import script from "./Unauthorized.vue?vue&type=script&lang=js&"
export * from "./Unauthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports